<template>
  <div class="col-lg-12" style="padding: 20px">
    <div class="main-card mb-3 card" style="margin-left: 10px">
      <div class="card-body">
        <h5 class="card-title">
          2023 Winter Camp 학습현황
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            2023 Winter Camp → 학습현황
          </div>
        </h5>
        <query-grid :config="config" ref="qg">
          <template #actions>
            <Create-Event ref="newSub" #default="m"> </Create-Event>
          </template>
          <template #resultactions="props"
            ><!--추후 제공예정-->

            <div style="text-align: right">
              <!--button class="btn btn-danger"  @click="addHistory()" >2022 Summer Camp 테스트</button-->
              <!--button class="btn btn-danger" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg"
              @click="creatingMode()">2022 Summer Camp 신청하기</button-->
              <router-link to="/events/2023_Winter"
                ><button class="btn btn-secondary">
                  신청목록
                </button></router-link
              >
              <router-link to="/events/2023_Winter_learningreview"
                ><button class="btn btn-secondary">
                  학습후기
                </button></router-link
              >
            </div>
          </template>

          <template #items="props">
            <tr
              v-for="record in props.records"
              v-bind:key="record.id + record.H_date"
              :class="{ 'table-danger': record.is_deleted }"
            >
              <td
                style="text-align: center"
                v-if="
                  this.$root.guiPerm != 'CLASS' &&
                  this.$root.guiPerm != 'ENTERPRISE'
                "
              >
                <Business v-if="record.t2" :biz="record.t2" />
              </td>

              <td style="text-align: center">
                <Business v-if="record.t1" :biz="record.t1" />
              </td>
              <td style="text-align: center">
                <!--a href="#" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg"
                  @click="moreStudentInfo(record)">{{ record.username }}</a-->
                {{ record.username }}
              </td>

              <td style="text-align: center">
                <Student :student="record" />
              </td>
              <td style="text-align: center">
                <span v-if="record.H_date">{{
                  record.H_date.substr(2, 8)
                }}</span>
              </td>
              <td style="text-align: center">
                <span v-if="record.sDateDi">{{
                  humanReadable(record.sDateDi)
                }}</span>
              </td>
            </tr>
          </template>
        </query-grid>
      </div>
    </div>
  </div>

  <Tree
    :key="$route.path"
    :tree-data="this.$root.businesses"
    :selectable="['CLASS']"
    render-button
    :callback="selectedBiz"
    :selectedNode="{ id: selData.activeBusiness }"
    ref="biz"
  />
</template>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import treeBtn from "../components/treeBtn";
import Business from "../components/Business";
import QueryGrid from "../components/QueryGrid";
import Student from "../components/detail_pages/Student";
import axios from "axios";
export default {
  name: "Home",
  components: {
    Tree,
    treeBtn,
    Business,
    Student,
    QueryGrid,
  },
  mounted() {
    if (this.$route.query.type) {
      /*this.typeFilter = {};
        this.typeFilter[this.$route.query.type] = true;*/
      this.$refs.qg.pushSetting(
        "status_filter_" + this.$route.query.type,
        true
      );
    }

    if (this.$root.guiPerm == "CLASS" || this.$root.guiPerm == "ENTERPRISE") {
      this.$refs.qg.pushSetting("status_filter_ACTIVE", true);
      this.config.columns.splice(0, 1);
    }

    this.$refs.qg.search();

    this.$watch(
      () => this.$route.query.type,
      function (toQuery, previousQuery) {
        // react to route changes...

        this.$refs.qg.pushSetting("status_filter_ACTIVE", false);
        this.$refs.qg.pushSetting("status_filter_INACTIVE", false);
        this.$refs.qg.pushSetting("status_filter_EVENT", false);
        if (toQuery)
          this.$refs.qg.pushSetting("status_filter_" + toQuery, true);

        this.$refs.qg.search();
      }
    );
  },
  methods: {
    doChange(name, value) {
      if (this.selData[name] === value) {
        delete this.changedData[name];
      } else {
        this.changedData[name] = value;
      }
    },
    selectedBiz(biz) {
      this.selBiz = biz;
      this.changedData.activeBusiness = biz.id;
    },
    doSend() {
      // 업데이트일 경우 patch /businesses/번호
      // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
      var data = {};
      if (this.creating) {
        data = {
          ...this.selData,
          ...this.changedData,
          activeBusiness: this.selBiz.id,
          product: this.selProduct.id,
          paymentMethod: this.selData.payMethod,
          hopeStart: this.selData.hopeStart,
          level: this.selData.level,
        };
      } else {
        data = this.changedData;
      }
      axios({
        method: this.creating ? "post" : "patch",
        url: "/students" + (!this.creating ? "/" + this.selData.id : ""),
        data: data,
      }).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "처리할 수 없습니다 " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.$refs.qg.search();
          $.notify(
            {
              // options
              message: "학생 생성이 처리되었습니다",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );
          bootstrap.Modal.getInstance(
            document.getElementById("studentModal")
          ).hide();
          if (this.selData.addSubscription) {
            $.notify(
              {
                // options
                message: "아이디 생성을 처리중입니다",
              },
              {
                // settings
                type: "info",
                z_index: 9999,
              }
            );

            axios
              .post("/subscriptions", {
                student: response.data.id,
                product: this.selProduct.id,
                paymentMethod: this.selData.payMethod,
                hopeStart: this.selData.hopeStart,
                level: this.selData.level,
              })
              .then((response) => {
                if (response.data.error) {
                  $.notify(
                    {
                      // options
                      message: "ID 추가 실패: " + response.data.error,
                    },
                    {
                      // settings
                      type: "danger",
                      z_index: 9999,
                    }
                  );
                } else {
                  if (
                    confirm(
                      "아이디까지 같이 신청이 완료되었습니다. 결제창으로 이동할까요?"
                    )
                  ) {
                    this.$router.push("/subscriptions?id=" + response.data.id);
                  } else {
                    this.$refs.qg.search();
                    $.notify(
                      {
                        // options
                        message: "아이디 신청되었습니다.",
                      },
                      {
                        // settings
                        type: "success",
                        z_index: 9999,
                      }
                    );
                  }
                }
              });
          }
        }
      });
    },
    fetchProducts(source) {
      var extras = "?";
      if (source) {
        extras += "source=" + source.id;
      }
      axios.get("/products" + extras).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.products = response.data.result;
        }
      });
    },

    fetchSubscriptions(student) {
      var extras = "";
      //this.levelRequest.record = {};
      axios
        .get('/subscriptions?status_filter=["ACTIVE"]&student=' + student.id)
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            student.subscriptions = response.data.result.filter(
              (x) => x.product == "MYUSE"
            );
          }
        });
    },
    fetchSubscriptionsChecked() {
      this.$refs.qg.checked.forEach((s) => {
        this.fetchSubscriptions(s);
      });
    },
    addHistory() {
      var data = {};
      var send = axios({
        method: "post",
        url: "/studies/historysave",
        data: data,
      });

      send.then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "처리할 수 없습니다 " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          $.notify(
            {
              // options
              message: "처리되었습니다",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );

          this.$router.push(
            this.creating
              ? response.data.id.toString()
              : "../" + response.data.id.toString()
          );
        }
      });
    },
    getDiff(value) {
      var moment = require("moment"); // moment 모듈불러오기

      const diff = moment().diff(value, "hours");
      const days = Math.floor(diff / 24);
      const hours = diff % 24;

      return -days;
    },
    humanReadable(seconds) {
      var hours = Math.floor(seconds / 3600);
      var mins = Math.floor((seconds - hours * 3600) / 60);
      var secs = seconds - hours * 3600 - mins * 60;

      //console.log(secs);

      return (
        (hours < 10 ? "0" : "") +
        hours +
        ":" +
        (mins < 10 ? "0" : "") +
        mins +
        ":" +
        (secs < 10 ? "0" : "") +
        secs
      );
    },
    creatingMode() {
      this.selData = {
        id: "",
        activeBusiness: "",
        username: "",
        password: "",
        hanName: "",
        engName: "",
        parentName: "",
        gender: "",
        bookclub_status: "",
        vocajoa_status: "",
        uracle_status: "",
        birth_of_day: "",
        phone: "",
        parentName: "",
        parentPhone: "",
        address: "",
        pass_allowed: false,
      };
      this.creating = true;
      this.changedData = {};
    },
    nvl(str) {
      if (typeof str == "undefined" || str == null) str = defaultStr;
      return str;
    },
  },
  filters: {
    currency(value) {
      return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  data() {
    return {
      config: {
        name: "이벤트 학습 현황",
        req_endpoint: "/studies/eventHistoryN/4/2024-01-02/2024-02-16",
        default_limit: 20,
        search_fields: [
          {
            id: "businesses",
            name: "소속선택",
            type: "business", // business, date, datetime,
          },
          {
            id: "search",
            name: "키워드검색",
            type: "text",
            placeholder: "아이디/이름/연락처",
          },
          {
            id: "date_filter",
            name: "날짜검색",
            type: "date",
            filter_type: {
              study_date: "학습일",
              regi_date: "등록일",
            },
          },
        ],
        columns: [
          {
            id: "biz",
            sortable: true,
            name: "학원",
            excel_print: (v) => {
              return v.t2.name;
            },
          },
          {
            id: "class",
            sortable: true,
            name: "클래스/캠퍼스",
            excel_print: (v) => {
              return v.t1.name;
            },
          },
          {
            id: "username",
            sortable: true,
            name: "아이디",
            excel_print: (v) => {
              return v.username;
            },
          },
          {
            id: "hanname",
            sortable: true,
            name: "이름",
            excel_print: (v) => {
              return v.name;
            },
          },
          {
            id: "study_date",
            sortable: true,
            name: "학습일자",
            excel_print: (v) => {
              return v.H_date || "";
            },
          },
          {
            id: "study_time",
            sortable: true,
            name: "학습시간",
            excel_print: (v) => {
              return this.humanReadable(v.sDateDi) || "";
            },
          },
        ],
        disable_init_search: true,
      },
      selBiz: {
        name: "",
      },
      subscriptions: [],
      selData: {
        id: "",
        activeBusiness: "",
        username: "",
        password: "",
        hanName: "",
        engName: "",
        parentName: "",
        gender: "",
        bookclub_status: "",
        vocajoa_status: "",
        uracle_status: "",
        birth_of_day: "",
        phone: "",
        parentName: "",
        parentPhone: "",
        address: "",
        pass_allowed: false,
      },
      changedData: {},
      selProduct: {},
      selectedSubscription: {
        id: 0,
      },
      products: [],
      creating: true,
    };
  },
};
</script>
